import api from './api';

export const linkService = {
  getAll: async () => {
    const response = await api.get('/links');
    return response.data;
  },

  getById: async (id) => {
    const response = await api.get(`/links/${id}`);
    return response.data;
  },

  create: async (linkData) => {
    const response = await api.post('/links', linkData);
    return response.data;
  },

  update: async (id, linkData) => {
    const response = await api.patch(`/links/${id}`, linkData);
    return response.data;
  },

  delete: async (id) => {
    const response = await api.delete(`/links/${id}`);
    return response.data;
  },
};

